/* tslint:disable */
/* eslint-disable */
// Generated by Microsoft Kiota
// @ts-ignore
import { createDashboardHistoryFromDiscriminatorValue, createValidationProblemDetailsFromDiscriminatorValue, type DashboardHistory, type ValidationProblemDetails } from '../../models/index.js';
// @ts-ignore
import { type BaseRequestBuilder, type Parsable, type ParsableFactory, type RequestConfiguration, type RequestInformation, type RequestsMetadata } from '@microsoft/kiota-abstractions';

/**
 * Builds and executes requests for operations under /Dashboard/GetHistory
 */
export interface GetHistoryRequestBuilder extends BaseRequestBuilder<GetHistoryRequestBuilder> {
    /**
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @returns {Promise<DashboardHistory[]>}
     * @throws {ValidationProblemDetails} error when the service returns a 400 status code
     */
     get(requestConfiguration?: RequestConfiguration<GetHistoryRequestBuilderGetQueryParameters> | undefined) : Promise<DashboardHistory[] | undefined>;
    /**
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @returns {RequestInformation}
     */
     toGetRequestInformation(requestConfiguration?: RequestConfiguration<GetHistoryRequestBuilderGetQueryParameters> | undefined) : RequestInformation;
}
export interface GetHistoryRequestBuilderGetQueryParameters {
    dashboardBookingId?: number;
}
/**
 * Uri template for the request builder.
 */
export const GetHistoryRequestBuilderUriTemplate = "{+baseurl}/Dashboard/GetHistory?dashboardBookingId={dashboardBookingId}";
/**
 * Metadata for all the requests in the request builder.
 */
export const GetHistoryRequestBuilderRequestsMetadata: RequestsMetadata = {
    get: {
        uriTemplate: GetHistoryRequestBuilderUriTemplate,
        responseBodyContentType: "application/json",
        errorMappings: {
            400: createValidationProblemDetailsFromDiscriminatorValue as ParsableFactory<Parsable>,
        },
        adapterMethodName: "sendCollection",
        responseBodyFactory:  createDashboardHistoryFromDiscriminatorValue,
    },
};
/* tslint:enable */
/* eslint-enable */
